import React from 'react';
import styled from 'styled-components';
import { DeviceType, ModalType } from '../../shared/enum/EnumRepository';
import { useDeviceStore } from '../../shared/store/deviceStore';
import { bottomWithSafeArea } from '../../shared/constants/safeArea';
import { useAuth } from '../../shared/hooks/useApi/useAuth';
import { useLanguageStore } from '../../shared/store/languageStore';
import { useModalStore } from '../../shared/store/portal/modalStore';
import { getModalMessage } from '../../shared/constants/modalMessages';
import createIcon from '../../asset/icon/create.png';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';
import HintWrapper from '../../shared/component/headless/button/HintWrapper';

const ExhibitionRightBottomIsland: React.FC = () => {
  const { deviceType } = useDeviceStore();
  const { user } = useAuth();
  useLanguageStore((s) => s.language);
  const { setStandardModal } = useModalStore();

  if (!user) return null;

  const label = getModalMessage('EXHIBITION_VENUE_REQUEST_TITLE');

  const handleRequest = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setStandardModal({
      modalType: ModalType.VENUE_REQUEST,
      title: null,
      value: null,
      handleChange: () => {},
    });
  };

  return (
    <GnbSection $isMobile={deviceType === DeviceType.MOBILE} onClick={(e) => e.stopPropagation()}>
      <HintWrapper content={label} toLeft={true}>
      <UniversalIconBtn
        size="fit"
        border={false}
        isTransparent
        backgroundImg={createIcon}
        onClick={handleRequest}
        aria-label={label}
      />
      </HintWrapper>
    </GnbSection>
  );
};

const GnbSection = styled.section<{ $isMobile: boolean }>`
  position: fixed;
  bottom: ${({ $isMobile }) =>
    $isMobile
      ? bottomWithSafeArea('clamp(30px, 7vw, 40px)')
      : 'clamp(25px, 5vh, 50px)'};
  right: ${({ $isMobile }) => $isMobile ? 'clamp(8px, 3vw, 16px)' : 'clamp(20px, 2vw, 30px)'};

  display: flex;
  align-items: center;
  z-index: 4;
`;

export default ExhibitionRightBottomIsland;
